var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { Group, Invitations } from "@@/Group";
import { NewInviteAcceptDecline } from "@/share/NewInvite";
import { BaseDialogState } from "../UIComponents/BaseDialog";
import { LetrEditrequestType, LetrRequestType } from "@/share/Letr";
import { LeterPermissionType } from "@@/Letr";
import { LetrLoadStatus } from "@/share/models";
import { LetrUI } from "./LetrUI";
import { AssignedTag } from "@@/Tags";
export var SelectedTab;
(function (SelectedTab) {
    SelectedTab[SelectedTab["Contact"] = 0] = "Contact";
    SelectedTab[SelectedTab["Connections"] = 1] = "Connections";
    SelectedTab[SelectedTab["Letrs"] = 2] = "Letrs";
})(SelectedTab || (SelectedTab = {}));
export class ManagedLetrsUIStore {
    constructor() {
        this.selectedContact = "";
        this.publicContactsById = new Map();
        this.contactsLoadStatus = 0;
        this.groupsById = new Map();
        this.newInvites = new Map();
        this.loadingGroups = false;
        this.loadingNewInvites = false;
        this.selectedtab = 0;
        this.selectedAssignee = "";
        this.allowSelEdit = false;
        this.showmenu = false;
        this.assigning = false;
        this.activeLetrId = '';
        this.loadingletrdetail = false;
        this.letrsById = new Map();
        this.hasMoreLetrs = true;
        this.selectedLetr = "";
        this.letrLoadStatus = LetrLoadStatus.Initial;
        this.activeletrdetails = undefined;
        this.userid = "";
        this.lastLetrTime = 0;
        this.loadingLetrs = false;
        makeObservable(this);
        APPEvent.addSubscriberForManagedContacts((mc) => {
            mc.forEach((m) => this.addPubliContact(m));
            this.setContactLoadStatus(2);
        });
        APPEvent.addSubscriberForManagedGroupInvites((minv) => {
            if (minv.email === this.selectedContact) {
                minv.inv.forEach((inv) => this.addNewInvite(inv));
                this.setLoadingNewInvites(false);
            }
        });
        APPEvent.addSubscriberForManagedGroups((mgrps) => {
            if (mgrps.email === this.selectedContact) {
                mgrps.grps.forEach((grp) => this.addGroup(grp));
                this.setLoadingGroups(false);
            }
        });
        APPEvent.addSubscriberForManagedLetrs((mlts) => {
            if (mlts.email === this.selectedContact) {
                // we need to set these now
                const mltrs = mlts.letrs;
                if (mltrs.length > 0) {
                    mltrs.forEach(lt => this.addLetr(this.convertLetrToLetrUI(lt)));
                }
                console.log(mltrs.length);
                if (mltrs.length < 20) {
                    this.setHasMoreLetrs(false);
                }
                this.loadingLetrs = false;
                this.setLetrLoadStatus(LetrLoadStatus.Loaded);
            }
        });
        APPEvent.addSubscriberForUserID((id) => this.userid = id);
        this.dialogState = new BaseDialogState();
        this.dialogState.setHeaderLabel("Managed Letr Details");
        this.dialogState.onClose = () => {
        };
        this.dialogState.onOk = () => this.assignLetrToUser();
        this.dialogState.onClose = () => {
            this.setShowMenu(false);
        };
        APPEvent.addSubscriberForLetrEdit((res) => {
            if (res.type === LetrEditrequestType.Add) {
                const exmem = this.getAssignedMemberId();
                if (exmem) {
                    this.removePreviousAssignee(exmem);
                }
            }
            else {
                this.loadManagedLetrDetail();
            }
            this.setSelectedAssignee("");
            this.setAssigning(false);
        });
        APPEvent.addSubscriberForLetrsResponse((res) => {
            if (res.type === LetrRequestType.FetchDetail && res.letrdetail !== undefined &&
                res.letrid === this.selectedLetr) {
                this.activeletrdetails = res.letrdetail;
                const amem = this.getAssignedMemberId();
                if (amem) {
                    this.setSelectedAssignee(amem);
                }
                this.setLetrDetailLoading(false);
            }
        });
    }
    getCreatorName() {
        if (this.activeletrdetails === undefined) {
            return "";
        }
        const parts = this.userid.split("__<<>>__");
        const orgmembs = this.activeletrdetails.memberDetails.filter((val) => !val.id.startsWith(parts[0]));
        if (orgmembs.length === 0) {
            return "";
        }
        return orgmembs[0].name + "(" + orgmembs[0].orgname + ")";
    }
    getAssignedMemberId() {
        if (this.activeletrdetails === undefined) {
            return "";
        }
        const parts = this.userid.split("__<<>>__");
        const orgmembs = this.activeletrdetails.memberDetails.filter((val) => val.id.startsWith(parts[0]) && val.id.indexOf("pub---") === -1);
        if (orgmembs.length === 0) {
            return "";
        }
        return orgmembs[0].id;
    }
    loadManagedLetrDetail() {
        if (!this.selectedLetr) {
            return;
        }
        this.setLetrDetailLoading(true);
        const req = {
            type: LetrRequestType.FetchDetail,
            letrid: this.selectedLetr,
        };
        Apphandler.sendMessage("letrs", req);
    }
    setLetrDetailLoading(loading) {
        this.loadingletrdetail = loading;
    }
    setLetrLoadStatus(status) {
        this.letrLoadStatus = status;
    }
    setHasMoreLetrs(hm) {
        this.hasMoreLetrs = hm;
    }
    addLetr(letr) {
        this.letrsById.set(letr.id, letr);
        if (this.lastLetrTime === 0 || this.lastLetrTime > letr.updatetime) {
            this.lastLetrTime = letr.updatetime;
        }
    }
    toggleMenu() {
        this.setShowMenu(!this.showmenu);
    }
    setShowMenu(show) {
        this.showmenu = show;
    }
    setAssigning(assign) {
        this.assigning = assign;
    }
    setActiveLetrId(letrid) {
        this.selectedLetr = letrid;
        APPEvent.publishActiveLetr(letrid);
    }
    getLetrById(id) {
        return this.letrsById.get(id);
    }
    removePreviousAssignee(id) {
        if (this.selectedAssignee != undefined) {
            this.setAssigning(true);
            const perm = {
                userid: id,
                permission: LeterPermissionType.Edit,
                roleid: ''
            };
            const req = {
                type: LetrEditrequestType.Delete,
                memberid: [perm],
                letrid: this.selectedLetr,
                tagids: [AssignedTag.id],
                isConnect: false
            };
            Apphandler.sendMessage("letredit", req);
        }
    }
    assignLetrToUser() {
        if (this.selectedAssignee != undefined) {
            this.setAssigning(true);
            const perm = {
                userid: this.selectedAssignee,
                permission: LeterPermissionType.Edit,
                roleid: ''
            };
            const req = {
                type: LetrEditrequestType.Add,
                memberid: [perm],
                letrid: this.selectedLetr,
                tagids: [AssignedTag.id],
                isConnect: false
            };
            Apphandler.sendMessage("letredit", req);
        }
    }
    setSelectedAssignee(grp) {
        this.selectedAssignee = grp;
    }
    addGroup(grp) {
        this.groupsById.set(grp.id, grp);
    }
    declineInvite(inv) {
        this.removeNewInvite(inv);
        const ninv = new NewInviteAcceptDecline();
        ninv.id = inv.id;
        ninv.accept = false;
        ninv.isPublic = true;
        ninv.email = this.selectedContact;
        Apphandler.sendMessage("newinviteresponse", ninv);
    }
    acceptInvite(inv) {
        const ninv = new NewInviteAcceptDecline();
        ninv.id = inv.id;
        ninv.accept = true;
        ninv.isPublic = true;
        ninv.email = this.selectedContact;
        Apphandler.sendMessage("newinviteresponse", ninv);
        this.removeNewInvite(inv);
    }
    removeNewInvite(inv) {
        this.newInvites.delete(inv.id);
    }
    get groups() {
        return Array.from(this.groupsById.values()).sort((g1, g2) => g1.name.localeCompare(g2.name));
    }
    get currentNewInvites() {
        return Array.from(this.newInvites.values()).sort((n1, n2) => n1.invitingusername.localeCompare(n2.invitingcompanyname));
    }
    addNewInvite(inv) {
        this.newInvites.set(inv.id, inv);
    }
    setSelectedContact(con) {
        this.selectedContact = con;
        this.newInvites = new Map();
        this.groupsById = new Map();
        this.letrsById = new Map();
        this.setActiveLetrId('');
        Apphandler.sendMessage("activemanagedcontact", con);
        if (this.selectedtab === SelectedTab.Contact) {
            this.loadGroups();
        }
        else if (this.selectedtab === SelectedTab.Connections) {
            this.loadNewInvites();
        }
        else if (this.selectedtab === SelectedTab.Letrs) {
            this.loadLetrs();
        }
    }
    setActiveTab(tab) {
        this.selectedtab = tab;
    }
    loadGroups() {
        if (!this.selectedContact || this.loadingGroups) {
            return;
        }
        this.setLoadingGroups(true);
        Apphandler.sendMessage("managedgroups", this.selectedContact);
    }
    loadLetrs() {
        if (!this.selectedContact && this.loadingLetrs) {
            return;
        }
        const time = new Date().getTime();
        this.loadManagedletrs(time);
    }
    getNextLetrsTime() {
        if (this.letrsById.size === 0) {
            return new Date().getTime();
        }
        const lts = this.getSortedLetrs();
        return lts[lts.length - 1].updatetime;
    }
    loadManagedletrs(time) {
        this.setLetrLoadStatus(LetrLoadStatus.Loading);
        const req = {
            email: this.selectedContact,
            before: time + (60 * 1000),
            count: 20
        };
        Apphandler.sendMessage("managedletrs", req);
    }
    loadMoreLetrs() {
        if (!this.hasMoreLetrs) {
            return;
        }
        if (!this.selectedContact && this.letrLoadStatus === LetrLoadStatus.Loading) {
            return;
        }
        this.loadManagedletrs(this.lastLetrTime);
    }
    setLoadingGroups(set) {
        this.loadingGroups = set;
    }
    setLoadingNewInvites(set) {
        this.loadingNewInvites = set;
    }
    loadNewInvites() {
        if (!this.selectedContact || this.loadingNewInvites) {
            return;
        }
        this.setLoadingNewInvites(true);
        Apphandler.sendMessage("managedgroupsinvites", this.selectedContact);
    }
    addPubliContact(cont) {
        this.publicContactsById.set(cont.email, cont);
    }
    loadPubliContacts() {
        this.setContactLoadStatus(1);
        Apphandler.sendMessage("getmanagedcontacts", "");
    }
    setContactLoadStatus(st) {
        this.contactsLoadStatus = st;
    }
    get publicContacts() {
        return Array.from(this.publicContactsById.values());
    }
    reset() {
        this.publicContactsById = new Map();
        this.selectedContact = "";
        this.groupsById = new Map();
        this.newInvites = new Map();
        this.letrsById = new Map();
        this.selectedLetr = '';
        this.hasMoreLetrs = true;
        this.lastLetrTime = 0;
        this.loadingLetrs = false;
        this.letrLoadStatus = LetrLoadStatus.Initial;
    }
    convertLetrToLetrUI(letr) {
        const lui = new LetrUI();
        lui.id = letr.id;
        lui.setUpdateTime(letr.letrMetadata.updatetime);
        lui.setSubject(letr.letrMetadata.subject);
        lui.setTags(letr.letrMetadata.tags);
        lui.setExternal(letr.isExternal);
        let message = '';
        if (letr.lastmessage != undefined) {
            message = letr.lastmessage;
        }
        lui.setLastmessage(message);
        lui.setRecepient(letr.recipients);
        lui.setIsGroup(this.checkIfLetrIsGroup(letr));
        lui.readonly = letr.readonly;
        lui.setLetrType(letr.letrtype);
        lui.setAuthor(letr.author);
        return lui;
    }
    checkIfLetrIsGroup(letr) {
        const memset = new Set(letr.recipients);
        memset.add(letr.author);
        return memset.size > 2 ? true : false;
    }
    getSortedLetrs() {
        return Array.from(this.letrsById.values()).sort(this.sortLetrByTime).reverse();
    }
    sortLetrByTime(l1, l2) {
        return l1.updatetime - l2.updatetime;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], ManagedLetrsUIStore.prototype, "selectedContact", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], ManagedLetrsUIStore.prototype, "publicContactsById", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ManagedLetrsUIStore.prototype, "contactsLoadStatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], ManagedLetrsUIStore.prototype, "groupsById", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], ManagedLetrsUIStore.prototype, "newInvites", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ManagedLetrsUIStore.prototype, "loadingGroups", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ManagedLetrsUIStore.prototype, "loadingNewInvites", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], ManagedLetrsUIStore.prototype, "selectedtab", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], ManagedLetrsUIStore.prototype, "selectedAssignee", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], ManagedLetrsUIStore.prototype, "allowSelEdit", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ManagedLetrsUIStore.prototype, "showmenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ManagedLetrsUIStore.prototype, "assigning", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ManagedLetrsUIStore.prototype, "activeLetrId", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ManagedLetrsUIStore.prototype, "loadingletrdetail", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], ManagedLetrsUIStore.prototype, "letrsById", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ManagedLetrsUIStore.prototype, "hasMoreLetrs", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], ManagedLetrsUIStore.prototype, "selectedLetr", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], ManagedLetrsUIStore.prototype, "letrLoadStatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ManagedLetrsUIStore.prototype, "activeletrdetails", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ManagedLetrsUIStore.prototype, "setLetrDetailLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ManagedLetrsUIStore.prototype, "setLetrLoadStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ManagedLetrsUIStore.prototype, "setHasMoreLetrs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [LetrUI]),
    __metadata("design:returntype", void 0)
], ManagedLetrsUIStore.prototype, "addLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ManagedLetrsUIStore.prototype, "setShowMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ManagedLetrsUIStore.prototype, "setAssigning", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ManagedLetrsUIStore.prototype, "setActiveLetrId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ManagedLetrsUIStore.prototype, "setSelectedAssignee", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Group]),
    __metadata("design:returntype", void 0)
], ManagedLetrsUIStore.prototype, "addGroup", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Invitations]),
    __metadata("design:returntype", void 0)
], ManagedLetrsUIStore.prototype, "removeNewInvite", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Invitations]),
    __metadata("design:returntype", void 0)
], ManagedLetrsUIStore.prototype, "addNewInvite", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ManagedLetrsUIStore.prototype, "setSelectedContact", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ManagedLetrsUIStore.prototype, "setActiveTab", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ManagedLetrsUIStore.prototype, "setLoadingGroups", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ManagedLetrsUIStore.prototype, "setLoadingNewInvites", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ManagedLetrsUIStore.prototype, "addPubliContact", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ManagedLetrsUIStore.prototype, "setContactLoadStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ManagedLetrsUIStore.prototype, "reset", null);
